<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="mb-2 font-regular">Loan Overview</h1>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="card card--no-shadow card-profile p-3">
          <loan-pie-chart
            v-if="loan_status_items.length"
            title="Loan Status"
            :items="loan_status_items"
          />
          <div v-else class="text-muted text-center py-5">Loading loan status chart...</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card--no-shadow card-profile p-3">
          <loan-pie-chart
            v-if="overdue_breakdown_items.length"
            title="Overdue Breakdown"
            :items="overdue_breakdown_items"
          />
          <div v-else class="text-muted text-center py-5">Loading overdue breakdown chart...</div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-12 p-2  card rounded-1">
        <div>
          <h2>Overdue By Amount<span style="font-size: 17px"></span></h2>
        </div>
        <div v-if="overdue_by_amount">
          <KeyValue
            objKey="0-10k"
            :objValue="overdue_by_amount._0_10k"
            :showBullet="true"
          />
          <KeyValue
            objKey="10K-20k"
            :objValue="overdue_by_amount._10k_20k"
            :showBullet="true"
          />
          <KeyValue
            objKey="20K-30k"
            :objValue="overdue_by_amount._20k_30k"
            :showBullet="true"
          />
          <KeyValue
            objKey="30K-40k"
            :objValue="overdue_by_amount._30k_40k"
            :showBullet="true"
          />
          <KeyValue
            objKey="40K-50k"
            :objValue="overdue_by_amount._40k_50k"
            :showBullet="true"
          />
          <KeyValue
            objKey="50K-Above"
            :objValue="overdue_by_amount._50k_and_above"
            :showBullet="true"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-12 p-2  card rounded-1">
        <div>
          <h2>Disburmement By Amount<span style="font-size: 17px"></span></h2>
        </div>
        <div v-if="disbursement_by_amount">
          <KeyValue
            objKey="0-10k"
            :objValue="disbursement_by_amount._0_10k"
            :showBullet="true"
          />
          <KeyValue
            objKey="10K-20k"
            :objValue="disbursement_by_amount._10k_20k"
            :showBullet="true"
          />
          <KeyValue
            objKey="20K-30k"
            :objValue="disbursement_by_amount._20k_30k"
            :showBullet="true"
          />
          <KeyValue
            objKey="30K-40k"
            :objValue="disbursement_by_amount._30k_40k"
            :showBullet="true"
          />
          <KeyValue
            objKey="40K-50k"
            :objValue="disbursement_by_amount._40k_50k"
            :showBullet="true"
          />
          <KeyValue
            objKey="50K-Above"
            :objValue="disbursement_by_amount._50k_and_above"
            :showBullet="true"
          />
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-12 p-2 card rounded-1">
        <div>
          <h2>Disburmement By Numbers<span style="font-size: 17px"></span></h2>
        </div>
        <div v-if="disbursement_by_numbers">
          <KeyValue
            objKey="All time Disbursements"
            :objValue="disbursement_by_numbers.total_disbursed_all_time"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Disbursements Today"
            :objValue="disbursement_by_numbers.total_disbursed_today"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Disbursements Yesterday"
            :objValue="disbursement_by_numbers.total_disbursed_yesterday"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Disbursements This Week"
            :objValue="disbursement_by_numbers.total_disbursed_this_week"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Disbursements This Month"
            :objValue="disbursement_by_numbers.total_disbursed_this_month"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Disbursements Last Month"
            :objValue="disbursement_by_numbers.total_disbursed_last_month"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Disbursements 2 Months Ago"
            :objValue="disbursement_by_numbers.total_disbursed_two_months_ago"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Disbursements 3 Months Ago"
            :objValue="disbursement_by_numbers.total_disbursed_three_months_ago"
            :showBullet="true"
            :showCurrency="true"
          />
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-12 p-2 card  rounded-1">
        <div>
          <h2>Recovery By Numbers<span style="font-size: 17px"></span></h2>
        </div>
        <div v-if="recovery_by_numbers">
          <KeyValue
            objKey="All time Recovery"
            :objValue="recovery_by_numbers.all_time_recovery"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Recovery Today"
            :objValue="recovery_by_numbers.recovery_today"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Recovery Yesterday"
            :objValue="recovery_by_numbers.recovery_yesterday"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Recovery This Week"
            :objValue="recovery_by_numbers.recovery_this_week"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Recovery This Month"
            :objValue="recovery_by_numbers.recovery_this_month"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Recovery Last Month"
            :objValue="recovery_by_numbers.recovery_last_month"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Recovery 2 Months Ago"
            :objValue="recovery_by_numbers.recovery_two_months_ago"
            :showBullet="true"
            :showCurrency="true"
          />
          <KeyValue
            objKey="Recovery 3 Months Ago"
            :objValue="recovery_by_numbers.recovery_three_months_ago"
            :showBullet="true"
            :showCurrency="true"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card--no-shadow card-profile">
          <div>
            <h2>Personel Statistics<span style="font-size: 17px"></span></h2>
          </div>
          <div class="row align-items-end my-4">
            <div class="col-xl-2 col-lg-6 col-12 px--5">
              <div class="form-group">
                <label>Start Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="personnel_start_date"
                />
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-12 px--5">
              <div class="form-group">
                <label>Stop Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="personnel_end_date"
                />
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-12 px--5">
              <div class="form-group">
                <button
                  @click.prevent="collectionPersonnelStats()"
                  class="button btn"
                >
                  <span class="custom-loader" v-if="personnel_data_loading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Please Wait</span
                    >
                  </span>
                  <span v-else>Submit</span>
                </button>
                <!-- clear button -->                
              </div>
            </div>
          </div>
          <CDataTable :items="personnel_stats" :fields="personnel_table_fields" sorter>
            <template #name="{ item }">
              <td>
                {{ `${item.first_name} ${item.last_name}` }} <br>
              </td>
            </template>
            <template #action="{ item }">
              <td class="table--action-mobile">
                <router-link v-if="permissions.includes('view-customer')"
                  :event="permissions.includes('view-customer') ? 'click' : ''" class="button btn-sm w-auto" :class="permissions.includes('view-customer')
                      ? ''
                      : 'disabled cursor-not-allowed'
                    " :to="{
                    name: 'CustomerComponent',
                    params: { slug: item.id }
                  }">
                  View
                </router-link>                
              </td>
            </template>
          </CDataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import KeyValue from "@/components/KeyValue.vue";
import CDataTable from "@/components/CDataTable.vue";
import LoanPieChart from "@/components/LoanPieChart.vue";

const personnel_table_fields = [
  "name",
  "collection_group",
  "call_rate",  
  "completed_cases",
  "delegated_case_amount",
  "delegated_cases",
  "recovered_amount"
];

export default {
  components: {
    KeyValue,
    CDataTable,
    LoanPieChart
  },
  computed: {
    permissions() {
      return this.$store.getters.permissions;
    }
  },
  data() {
    return {
      personnel_table_fields,
      loan_status_items: [],
      overdue_breakdown_items: [],
      overdue_by_amount: null,
      disbursement_by_amount: null,
      disbursement_by_numbers: null,
      recovery_by_numbers: null,
      personnel_start_date: "",
      personnel_end_date: "",
      personnel_stats: [],
      personnel_data_loading: false
    };
  },
  methods: {
    async loanStatusStas() {
      try {
        const res = await ApiService.get("stats/stats_by_loan_status");
        this.loan_status_items = res.data.data || [];
      } catch (error) {
        console.log(error.response);
      }
    },
    async overdueBreakDown() {
      try {
        const res = await ApiService.get("stats/overdue_breakdown");
        this.overdue_breakdown_items = res.data.data || [];
      } catch (error) {
        console.log(error.response);
      }
    },
    async overdueByAmount() {
      try {
        const res = await ApiService.get("stats/overdue_by_amount");
        this.overdue_by_amount = res.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },

    async dssbursementByAmount() {
      try {
        const res = await ApiService.get("stats/disbursement_by_amount");
        this.disbursement_by_amount = res.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async dssbursementByNumbers() {
      try {
        const res = await ApiService.get("stats/disbursement_by_numbers");
        this.disbursement_by_numbers = res.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async recoveryByNumbers() {
      try {
        const res = await ApiService.get("stats/recovery_by_numbers");
        this.recovery_by_numbers = res.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async collectionPersonnelStats() {
      this.personnel_data_loading = true;
      try {
        var url = `stats/instant_loan_collection_personels`;
        if (this.personnel_start_date && this.personnel_end_date) {
          url =
            url +
            `?start_date=${this.personnel_start_date}&end_date=${this.personnel_end_date}`;
        }

        const response = await ApiService.get(url);
        console.log(response);
        this.personnel_stats = response.data.data;
        this.personnel_data_loading = false;
      } catch (error) {
        this.personnel_data_loading = false;
        console.log(error.response);
      }
    }
  },
  mounted() {
    if (this.can("dashboard")) {
      this.loanStatusStas();
      this.overdueBreakDown();
      this.dssbursementByAmount();
      this.dssbursementByNumbers();
      this.recoveryByNumbers();
      this.overdueByAmount();
      this.collectionPersonnelStats();
    }
  }
};
</script>

<style></style>
